module.exports = __webpack_public_path__ + "media/images/icons/pointer_landing-a73a31522c0b3344b15ecbab2e4a9d42.svg";